import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import http from "./axios"

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'base-name',
            redirect: (to) => {
                if (to && to.path && to.path === "/") {
                    return "/dashboard"
                }
            }
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: () => import('./views/dashboard/index'),
            meta: {
                title: "Бошқарув панели"
            }
        },
        // {
        //     path: '/contacts',
        //     name: 'contacts',
        //     component: () => import('./views/contacts/index')
        // },
        {
            path: '/pledge-monitoring',
            name: 'pledge-monitoring',
            component: () => import('@/views/pledge-monitoring/PledgeMonitoringList'),
            meta: {
                permission: 'PLEDGE_MONITORING',
                actionPermission: 'PLEDGE_MONITORING_APPLICATION_LIST',
                title: "Жорий гаров мониторинги"
            }
        },
        {
            path: '/pledge-monitoring/:id/credit',
            name: 'pledge-monitoring-credit-list',
            component: () => import('@/views/pledge-monitoring/credit/CreditList.vue'),
            meta: {
                permission: 'PLEDGE_MONITORING',
                actionPermission: 'PLEDGE_MONITORING_CREDIT_LIST'
            }
        },
        {
            path: '/pledge-monitoring/:id/credit/:creditId/pledge',
            name: 'pledge-monitoring-credit-pledge-list',
            component: () => import('@/views/pledge-monitoring/pledge/PledgeList.vue'),
            meta: {
                permission: 'PLEDGE_MONITORING',
                actionPermission: 'PLEDGE_MONITORING_PLEDGE_LIST'
            }
        },
        {
            path: '/pledge-monitoring/application',
            name: 'pledge-monitoring-application',
            component: () => import('@/views/pledge-monitoring/application/Application.vue'),
            meta: {
                permission: 'PLEDGE_MONITORING',
                actionPermission: 'PLEDGE_MONITORING_APPLICATION_ADD'
            }
        },
        {
            path: '/pledge-monitoring/application/:applicationId',
            name: 'pledge-monitoring-application-edit',
            component: () => import('@/views/pledge-monitoring/application/Application.vue'),
            meta: {
                permission: 'PLEDGE_MONITORING',
                actionPermission: 'PLEDGE_MONITORING_APPLICATION_EDIT'
            }
        },
        {
            path: '/pledge-monitoring/application/view/:applicationId',
            name: 'pledge-monitoring-application-view',
            component: () => import('@/views/pledge-monitoring/application/ApplicationView.vue'),
            meta: {
                permission: 'PLEDGE_MONITORING',
                actionPermission: 'PLEDGE_MONITORING_APPLICATION_VIEW'
            }
        },
        {
            path: '/initial-monitoring',
            name: 'initial-monitoring',
            component: () => import('@/views/initial-monitoring/InitialMonitoringList.vue'),
            meta: {
                permission: 'INITIAL_MONITORING',
                actionPermission: 'INITIAL_MONITORING_APPLICATION_LIST',
                title: "Дастлабки гаров мониторинги"
            }
        },
        {
            path: '/initial-monitoring/:id/credit',
            name: 'initial-monitoring-credit-list',
            component: () => import('@/views/initial-monitoring/credit/CreditList.vue'),
            meta: {
                permission: 'INITIAL_MONITORING',
                actionPermission: 'INITIAL_MONITORING_CREDIT_LIST'
            }
        },
        {
            path: '/initial-monitoring/:id/credit/:creditId/pledge',
            name: 'initial-monitoring-credit-pledge-list',
            component: () => import('@/views/initial-monitoring/pledge/PledgeList.vue'),
            meta: {
                permission: 'INITIAL_MONITORING',
                actionPermission: 'INITIAL_MONITORING_PLEDGE_LIST'
            }
        },
        {
            path: '/initial-monitoring/application',
            name: 'initial-monitoring-application',
            component: () => import('@/views/initial-monitoring/application/InitialApplication.vue'),
            meta: {
                permission: 'INITIAL_MONITORING',
                actionPermission: 'INITIAL_MONITORING_APPLICATION_ADD'
            }
        },
        {
            path: '/initial-monitoring/application/:applicationId',
            name: 'initial-monitoring-application-edit',
            component: () => import('@/views/initial-monitoring/application/InitialApplication.vue'),
            meta: {
                permission: 'INITIAL_MONITORING',
                actionPermission: 'INITIAL_MONITORING_APPLICATION_EDIT'
            }
        },
        {
            path: '/initial-monitoring/application/view/:applicationId',
            name: 'initial-monitoring-application-view',
            component: () => import('@/views/initial-monitoring/application/InitialApplicationView.vue'),
            meta: {
                permission: 'INITIAL_MONITORING',
                actionPermission: 'INITIAL_MONITORING_APPLICATION_VIEW'
            }
        },
        {
            path: '/targeted-inspection-monitoring',
            name: 'targeted-inspection-monitoring',
            component: () => import('@/views/targeted-inspection-monitoring/TargetedInspectionMonitoringList.vue'),
            meta: {
                permission: 'TARGETED_INSPECTION_MONITORING',
                actionPermission: 'TARGETED_INSPECTION_MONITORING_APPLICATION_LIST',
                title: 'Мақсадли инспексион мониторинг'
            }
        },
        {
            path: '/targeted-inspection-monitoring/:id/credit',
            name: 'targeted-inspection-monitoring-credit-list',
            component: () => import('@/views/targeted-inspection-monitoring/credit/TargetedInspectionCreditList.vue'),
            meta: {
                permission: 'TARGETED_INSPECTION_MONITORING',
                actionPermission: 'TARGETED_INSPECTION_MONITORING_CREDIT_LIST'
            }
        },
        {
            path: '/targeted-inspection-monitoring/application/:applicationId',
            name: 'targeted-inspection-monitoring-application-edit',
            component: () => import('@/views/targeted-inspection-monitoring/application/TargetedInspectionApplication.vue'),
            meta: {
                permission: 'TARGETED_INSPECTION_MONITORING',
                actionPermission: 'TARGETED_INSPECTION_MONITORING_APPLICATION_EDIT'
            }
        },
        {
            path: '/targeted-inspection-monitoring/application/view/:applicationId',
            name: 'targeted-inspection-monitoring-application-view',
            component: () => import('@/views/targeted-inspection-monitoring/application/TargetedInspectionApplicationView.vue'),
            meta: {
                permission: 'TARGETED_INSPECTION_MONITORING',
                actionPermission: 'TARGETED_INSPECTION_MONITORING_APPLICATION_VIEW'
            }
        },
        /*{
            path: '/current-inspection-monitoring',
            name: 'current-inspection-monitoring',
            component: () => import('@/views/current-inspection-monitoring/CurrentInspectionMonitoringList.vue'),
            meta: {
                permission: 'CURRENT_INSPECTION_MONITORING',
                title: 'Жорий инспексион мониторинг'
            }
        }*/
        /*{
            path: '/pledge-monitoring/:id/item/list',
            name: 'pledge-monitoring-edit-items-list',
            component: () => import('@/views/pledge-monitoring/PledgeMonitoringItemList'),
            meta: {
                permission: 'PLEDGE_MONITORING',
                actionPermission: 'PLEDGE_MONITORING_EDIT'
            }
        },
        {
            path: '/pledge-monitoring/:id/item/new',
            name: 'pledge-monitoring-item-new',
            component: () => import('@/views/pledge-monitoring/item/PledgeMonitoringItemEdit'),
            meta: {
                permission: 'PLEDGE_MONITORING',
                actionPermission: 'PLEDGE_MONITORING_NEW_ITEM'
            }
        },
        {
            path: '/pledge-monitoring/:id/item/edit/:itemId',
            name: 'pledge-monitoring-item-edit',
            component: () => import('@/views/pledge-monitoring/item/PledgeMonitoringItemEdit'),
            meta: {
                permission: 'PLEDGE_MONITORING',
                actionPermission: 'PLEDGE_MONITORING_EDIT_ITEM'
            }
        }*/
    ]
})

router.beforeEach((to, from, next) => {

    if (to.path.split("/")[1] !== from.path.split("/")[1]) {
        store.dispatch("deleteFiltersData")
    }

    if (to.meta.permission && (to.meta?.permission !== from.meta?.permission || to.meta?.actionPermission !== from.meta?.actionPermission)) {
        http.post('permission/user/actions', {code: to.meta.permission})
            .then(res => {
                store.dispatch('setPermission', res.data)
                if (store.state.menus.length > 0) {
                    if (store.state.menus.indexOf(to.meta.permission) >= 0) {
                        to.meta.actionPermission
                            ? res.data.includes(to.meta.actionPermission)
                                ? next()
                                : next(to.meta?.allowFullPathRedirect ? to.fullPath.split("/")[1] : to.path.split("/")[1])
                            : next()
                    } else {
                        next("/dashboard")
                    }
                } else {
                    http.get('permission/user/menu')
                        .then(menuRes => {
                            if (menuRes && menuRes.data && menuRes.data.menus) {
                                store.dispatch("setMenus", menuRes.data.menus)
                                if (store.state.menus.indexOf(to.meta.permission) >= 0) {
                                    if (to.meta.actionPermission && res.data.includes(to.meta.actionPermission)) {
                                        next()
                                    } else {
                                        next(to.meta?.allowFullPathRedirect ? to.fullPath.split("/")[1] : to.path.split("/")[1])
                                    }
                                } else {
                                    next("/dashboard")
                                }
                            }
                        }).catch((err) => {
                        console.error(err);
                        next("/dashboard")
                    });
                }

            }).catch((err) => {
            console.error(err);
            next("/dashboard")
        })
    } else {
        next()
    }

    return next;
});

router.afterEach((to) => {
    const base = 'E-monitoring'
    document.title = to.meta?.title
        ? `${to.meta.title} | ${base}`
        : base
})

export default router;